import { makeStyles } from '@material-ui/core/styles';

export function useFormStyles() {
    const useStyles = makeStyles((theme) => ({
        title: {
            fontSize: '1.5rem',
            fontWeight: 500,
            marginBottom: theme.spacing(2),
        },
        formControl: {
            width: '100%',
        },
        textField: {
            color: '#706E7A',
        },
        footer: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(2),
            gap: theme.spacing(1),
        },
        button: {
            color: '#004B97',
            fontSize: '0.95rem',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        saveButton: {
            color: '#FFF',
            backgroundColor: '#004B97',
            fontSize: '0.95rem',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: '#003366',
            },
        },
        switchBase: {
            "&$checked": {
                color: "#2E7D32", // verde
            },
            "&$checked + $track": {
                backgroundColor: "#2E7D32",
            },
        },
        checked: {},
        track: {},
    }));

    const classes = useStyles();

    return {
        classes,
    };
}